<!-- Photo, location and contacts -->
<app-card>
  <!-- Photo -->
  <div class="p-4 print:hidden">
    <!-- TODO: update the photo to be provided by basics interface -->
    <img class="p-2 mt-2 rounded-full shadow-lg m-auto border border-indigo-200 "
      width="218"
      height="218"
      alt="portrait"
      src="assets/leo-meirelles.webp" />
  </div>
  <!-- Details -->
  <div *ngIf="basics"
    class="p-4 flex flex-col lg:flex-row lg:gap-4 justify-between print:p-0 print:h-full">
    <!-- Top: photo, basic information -->
    <div>
      <!-- Name -->
      <h1 class="font-semibold text-2xl whitespace-nowrap print:text-xl text-indigo-900">{{basics.name}}</h1>
      <!-- Label and pronoun -->
      <div class="flex justify-between">
        <!-- Label -->
        <p>{{basics.label}}</p>
        <!-- Pronoun -->
        <p class="text-gray-500">{{basics.pronoun}}</p>
      </div>
      <!-- Location -->
      <p class="text-center text-gray-500 text-sm mb-2">
        {{basics.location.city}}, &nbsp;
        {{basics.location.region}}, &nbsp;
        {{basics.location.countryCode}}
      </p>
    </div>
    <!-- Bottom: contact information -->
    <div class="flex flex-col justify-end">
      <!-- Phone contact -->
      <p class="flex text-indigo-600">
        <span class="material-icons-outlined text-black">
          phone
        </span>
        <a class="pl-2"
          rel="noopener noreferrer"
          href="tel:{{basics.phone}}">
          {{basics.phone}}
        </a>
      </p>
      <!-- Email contact -->
      <p class="flex pt-1 text-indigo-600">
        <span class="material-icons-outlined text-black">
          alternate_email
        </span>
        <a class="pl-2"
          rel="noopener noreferrer"
          href="mailto:{{basics.email}}">
          {{basics.email}}
        </a>
      </p>
      <!-- Website -->
      <p class="flex pt-1 text-indigo-600">
        <span class="material-icons-outlined text-black">
          contact_page
        </span>
        <a class="pl-2"
          rel="noopener noreferrer"
          href="{{basics.website}}">
          {{basics.website}}
        </a>
      </p>
    </div>
  </div>
</app-card>